export const isAsciiGraphic = (str: string) => {
  let code, i, len

  for (i = 0, len = str.length; i < len; i++) {
    code = str.charCodeAt(i)

    if (code < 0x21 || code > 0x7e) {
      return false
    }
  }
  return true
}
